// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-one-page-js": () => import("/opt/build/repo/src/templates/OnePage.js" /* webpackChunkName: "component---src-templates-one-page-js" */),
  "component---src-pages-admin-js": () => import("/opt/build/repo/src/pages/admin.js" /* webpackChunkName: "component---src-pages-admin-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

